// extracted by mini-css-extract-plugin
module.exports = {"article-tag":"_3JnW1eqyCcqhl0MQpm2T"};